export default "__VITE_ASSET__Bw5ejFt3__"